import { render, staticRenderFns } from "./pos-price-edition-modal.vue?vue&type=template&id=5631a586&scoped=true&"
import script from "./pos-price-edition-modal.vue?vue&type=script&lang=ts&"
export * from "./pos-price-edition-modal.vue?vue&type=script&lang=ts&"
import style0 from "./pos-price-edition-modal.vue?vue&type=style&index=0&id=5631a586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5631a586",
  null
  
)

export default component.exports